"use client";

import { useState } from "react";
import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import { useCareersMarket } from "@/components/careers/CareersMarketContext";
import type { Market } from "@/components/careers/market";

const MARKET_LABELS: Record<Market, string> = {
  UK: "UK Careers",
  US: "US Careers",
};

interface CareersHeroFiltersProps {
  markets: Market[];
}

export function CareersHeroFilters({ markets }: CareersHeroFiltersProps) {
  const ctx = useCareersMarket();
  const [localMarket, setLocalMarket] = useState<Market | null>(null);
  const activeMarket = ctx ? ctx.market : localMarket;
  const setActiveMarket = ctx ? ctx.setMarket : setLocalMarket;

  return (
    <div className="flex flex-col items-start gap-3">
      {markets.map((market) => {
        const isActive = activeMarket === market;
        return (
          <button
            key={market}
            type="button"
            aria-pressed={isActive}
            onClick={() =>
              setActiveMarket((prev) => (prev === market ? null : market))
            }
            className={cn(
              "group inline-flex items-center gap-2 text-base 2xl:text-lg transition-colors",
              isActive ? "text-white" : "text-white/70 hover:text-white"
            )}
          >
            <span
              className={cn(
                "font-subheading text-xl 2xl:text-2xl leading-none transition-colors",
                isActive ? "text-white" : "text-white/40 group-hover:text-white/70"
              )}
            >
              [
            </span>
            <span className="font-subheading">{MARKET_LABELS[market]}</span>
            <Plus className="h-4 w-4" />
            <span
              className={cn(
                "font-subheading text-xl 2xl:text-2xl leading-none transition-colors",
                isActive ? "text-white" : "text-white/40 group-hover:text-white/70"
              )}
            >
              ]
            </span>
          </button>
        );
      })}
    </div>
  );
}
